import { oembedData } from './OembedStore';

export const updateOembedData = (value) => oembedData.update((oldValue) => value);
